import { render, staticRenderFns } from "./Valoracion.vue?vue&type=template&id=60c566ba"
import script from "./Valoracion.vue?vue&type=script&setup=true&lang=js"
export * from "./Valoracion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports